import React from "react";
import { Container, Spinner, Tab, Tabs } from "react-bootstrap";
import { dateFormatter } from "../../../../_helpers/dateFormatter";
import { faEarthAfrica } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EmptyFeedCard from "../../../../_uiComponents/EmptyFeedCard";

function CompanySearch({ companySearch, companyNavigation, companiesLoading }) {
  return (
    <div>
      {companiesLoading ? (
        <div className="d-flex justify-content-center align-items-center w-100">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div>
          <h2 className="mb-4">Showing {companySearch.length} Result</h2>
          {Array.isArray(companySearch) && companySearch.length ? (
            <div className="row">
              {companySearch &&
                Array.isArray(companySearch) &&
                companySearch.map((data) => (
                  <div className="col-md-4 mb-4">
                    <div className="p-4 bg-white border position-relative h-100 border-radius-10 shadow-2">
                      <div className="upper border-bottom">
                        <div className="d-flex mb-3 align-items-start">
                          <img
                            src={
                              data?.logo
                                ? data.logo
                                : "/assets/images/building-placeholder.png"
                            }
                            alt="company logo"
                            className="border-radius-10 mr-3"
                            style={{ width: "48px", height: "48px" }}
                          />
                          <div className="job-info">
                            <h3 className="font-weight-medium mb-1 text-capitalize cursor-pointer text-primary">
                              {data?.name}
                            </h3>
                            <p className="mb-1 fs-14 text-capitalize">
                              {data?.industry ? (
                                <>
                                  <span className="text-muted">
                                    {data?.industry}
                                  </span>
                                </>
                              ) : null}
                            </p>
                          </div>
                        </div>
                        {data?.about ? (
                          <>
                            <p className="text-muted">{data?.about}</p>
                          </>
                        ) : null}

                        <div className="d-flex align-items-center fs-smallest text-primary mb-3">
                          {data?.industry ? (
                            <>
                              <p className="mb-0 bg-light-blue text-capitalize  rounded-lg py-1 px-3 mr-2">
                                {data?.industry}
                              </p>
                            </>
                          ) : null}
                          {data?.size ? (
                            <>
                              <p className="mb-0 bg-light-blue text-capitalize rounded-lg py-1 px-3 mr-2">
                                {data?.size} employees
                              </p>
                            </>
                          ) : null}

                          <p className="mb-0 bg-light-blue text-capitalize bg-primary-light rounded-lg py-1 px-3 mr-2">
                            Georgia
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center mt-3">
                        <div className="job-bottom d-flex align-items-center justify-content-between w-100">
                          {data?.url ? (
                            <>
                              <div className="text-primary d-flex align-items-center">
                                <FontAwesomeIcon
                                  icon={faEarthAfrica}
                                  className="mr-2"
                                />
                                <a
                                  href={data?.url}
                                  target="_blank"
                                  className="font-weight-medium mb-0"
                                >
                                  Visit Website
                                </a>
                              </div>
                            </>
                          ) : null}

                          <button
                            className="btn btn-primary ml-auto py-2"
                            onClick={() => companyNavigation(data?.id)}
                          >
                            View
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          ) : (
            <EmptyFeedCard message={"no result found."} />
          )}
        </div>
      )}
    </div>
  );
}

export default CompanySearch;
